import { 
    MDBCol, 
    MDBContainer, 
    MDBRow,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBBtn, } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import Chart from 'chart.js/auto'
const Typhoon = () => {
    const [data1, setScene1] = useState([])
    const [data2, setScene2] = useState([])

    const [chart1, setChart1] = useState(null);
    const [chart2, setChart2] = useState(null);
    useEffect(()=>{
        fetch(`${process.env.REACT_APP_URL}disaster/find`)
        .then(result => result.json())
        .then(data => {
            
            const datas1 = data.data.filter(l => l.scenario === "1")
            const datas2 = data.data.filter(l => l.scenario === "2")
            setScene1(datas1)
            setScene2(datas2)
            
        })
        
    },[])

    useEffect(()=>{
        const choice = [
            "Scene 1 Choices"
        ]
        // --------------------
        const choicemaleA = data1.filter(e => e.choice === 'a' && e.gender === 'male')
        const choicefemaleB = data1.filter(e => e.choice === 'b' && e.gender === 'female')

        const choicefemaleA = data1.filter(e => e.choice === 'a' && e.gender === 'female')
        const choicemaleB = data1.filter(e => e.choice === 'b' && e.gender === 'male')
        const scene1 = document.getElementById("scene1")
        if (scene1) {
            const existingChart = Chart.getChart(scene1);
            if (existingChart) {
                existingChart.destroy();
            }
            const newChart = new Chart(scene1, 
                {
                    type: 'bar',
                    data: {
                      labels: choice,
                      datasets: [
                        {
                          label: 'Choice A Male',
                          data: [choicemaleA.length]
                        },
                        {
                            label: 'Choice B Female',
                            data: [choicefemaleB.length]
                        },
                        {
                            label: 'Choice A Female',
                            data: [choicefemaleA.length]
                        },
                        {
                            label: 'Choice B Male',
                            data: [choicemaleB.length]
                        },
                      ]
                    }
                  });
            setChart1(newChart);
        }
    },[data1])

    useEffect(()=>{
        const choice = [
            "Scene 2 Choices"
        ]
        const choicemaleA = data2.filter(e => e.choice === 'a' && e.gender === 'male')
        const choicefemaleB = data2.filter(e => e.choice === 'b' && e.gender === 'female')

        const choicefemaleA = data2.filter(e => e.choice === 'a' && e.gender === 'female')
        const choicemaleB = data2.filter(e => e.choice === 'b' && e.gender === 'male')
        const scene2 = document.getElementById("scene2")
        if (scene2) {
            const existingChart = Chart.getChart(scene2);
            if (existingChart) {
                existingChart.destroy();
            }
            const newChart = new Chart(scene2, 
                {
                    type: 'bar',
                    data: {
                      labels: choice,
                      datasets: [
                        {
                            label: 'Choice A Male',
                            data: [choicemaleA.length]
                          },
                          {
                              label: 'Choice B Female',
                              data: [choicefemaleB.length]
                          },
                          {
                              label: 'Choice A Female',
                              data: [choicefemaleA.length]
                          },
                          {
                              label: 'Choice B Male',
                              data: [choicemaleB.length]
                          },
                      ]
                    }
                  });
            setChart2(newChart);
        }
    },[data2])

    const handlePrint = () => {
        window.print();
    };
    return(
        <MDBContainer>
            <MDBRow>
                <MDBCol className="mt-5">
                    <MDBBtn onClick={handlePrint}>
                        PRINT
                    </MDBBtn>
                </MDBCol>
            </MDBRow>
            <MDBContainer id="section-to-print">
            <MDBRow>
                <MDBCol>
                <MDBCard className="mt-5"> 
                <MDBCardBody>
                    <MDBCardTitle className="">Scene 1: Before Flood Scene </MDBCardTitle>
                    <div>
                    <canvas id="scene1">

                    </canvas>
                    </div>
                    
                    <MDBCardText>
                    Narrator: It was past noon and you can see the flood starts to rise up as the heaving rain continues to fall. What Will you do?
                    </MDBCardText>
                    <MDBCardText>
                    Choice A: Stay At Home
                    </MDBCardText>
                    <MDBCardText>
                    Choice B: Go to Evacuation Center
                    </MDBCardText>
                </MDBCardBody>
                </MDBCard>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                <MDBCard className="mt-5"> 
                <MDBCardBody>
                    <MDBCardTitle className="">Scene 2: During Flood Scene </MDBCardTitle>
                    <canvas  id="scene2">
                        
                    </canvas>
                    <MDBCardText>
                    NARRATION: The flood starts to reach high places as the heavy rain continues to fall and you need to move out of your house, what will you do?
                    </MDBCardText>
                    <MDBCardText>
                    Choice A: Go now to Evacuation Centre 
                    </MDBCardText>
                    <MDBCardText>
                    Choice B: Go to the roof, call for help, and wait for them to arrive
                    </MDBCardText>
                </MDBCardBody>
                </MDBCard>
                </MDBCol>
            </MDBRow>
            </MDBContainer>
            
            
        </MDBContainer>
    )
}

export default Typhoon;